export const isValidEmail = (email: string) => {
  const isValid = /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{1,4}\S$/i.test(email);
  return isValid;
};
